import { render } from "./transaciton.vue?vue&type=template&id=750f6ef4&scoped=true"
import script from "./transaciton.vue?vue&type=script&lang=js"
export * from "./transaciton.vue?vue&type=script&lang=js"

import "./transaciton.vue?vue&type=style&index=0&id=750f6ef4&lang=scss&scoped=true"
import "./transaciton.vue?vue&type=style&index=1&id=750f6ef4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750f6ef4"]])

export default __exports__